import '../components/scrollTarget';
import { pageBannerTop, menuLang } from '../layout';
document.addEventListener("DOMContentLoaded", function(){
	pageBannerTop();
	menuLang();
});